import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { ListStockResponse, getAllStocks } from '@apis/stock';

export const useAllStockList = (enabled: boolean = true) => {
  const queryOptions: UseQueryOptions<
    PageResponse<ListStockResponse>,
    Error
  > = {
    queryKey: ['stocksAll'],
    queryFn: () => {
      return getAllStocks();
    },
    enabled,
  };
  return useQuery(queryOptions);
};
